import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: { display: "flex", alignItems: "center" },
  icon: { color: grey[500], marginLeft: 8, cursor: "pointer" },
}));

export default useStyles;
